import SectionContainer from '../../components/common/SectionContainer'
import { useEffect, useState } from 'react'
import Button from '../../components/common/Button'
import HtmlInput from '../../components/common/data-form/HtmlInput'
import fetchAPI from '../../common/fetchAPI'
import {
    formatMoney,
    getGoogleLoginRequestUri,
    getUserDisplayName,
} from '../../common/helpers'
import ResourceList from '../../components/admin/ResourceList'
import BlockStack from '../../components/common/BlockStack'
import ContactCard from './clients/ContactCard'
import ContactCardContactInfo from './clients/ContactCardContactInfo'
import ContactCardTags from './clients/ContactCardTags'
import OrgCard from '../contacts/OrgCard'
import Break from '../../components/common/Break'
import { Link } from 'react-router-dom'
import FavoriteContacts from '../contacts/FavoriteContacts'

// https://app.aco.digital/pages/criticalbugs
// https://app.aco.digital/tasks/66c391ba94871c5bc52b906f

function T() {
    console.log('rere')
    return Array(40)
        .fill(0)
        .map((_, index) => (
            <div key={index}>
                <Link to="/projects">Test {index + 1}</Link>
                <Break />
            </div>
        ))
}

const basicFilterFields = {
    search: true,
    sort: {
        name: {
            label: 'Name',
            dbFields: ['lastName', 'firstName', 'email'],
            asc: true,
        },
    },
}

const adminUserFilterFields = {
    ...basicFilterFields,
    filters: {
        onCollections: {
            label: 'Collections',
            dbField: 'onCollections',
            options: [
                {
                    label: 'Any',
                    value: 'undefined',
                },
                {
                    label: 'Yes',
                    value: 'true',
                },
                {
                    label: 'No',
                    value: 'false',
                },
            ],
        },

        onBlackList: {
            label: 'Blacklisted',
            dbField: 'onBlackList',
            options: [
                {
                    label: 'No',
                    value: 'false',
                },
                {
                    label: 'Yes',
                    value: 'true',
                },
                {
                    label: 'Any',
                    value: 'undefined',
                },
            ],
        },
        isPremiumUser: {
            label: 'Subscription',
            dbField: 'isPremiumUser',
            options: [
                {
                    label: 'Any',
                    value: 'undefined',
                },
                {
                    label: 'Free',
                    value: 'false',
                },
                {
                    label: 'Premium',
                    value: 'true',
                },
            ],
        },
    },
}

export default function Dev() {
    let initialQuery = {}
    useEffect(() => {
        console.log('Scroll Y after nav:', window.scrollY)
        setTimeout(() => {
            console.log('Scroll Y after delay:', window.scrollY)
        }, 100)
    }, [location])
    initialQuery = {
        fields: 'avatarUrl,firstName,lastName,email,onHold,onBlackList,isBlocked,onCollections,teamRoles,isPremiumUser,role,startDate,labels,contactDetails,orgsData,labels,isPaid',
        populate: 'contactDetails,orgsData',
    }
    initialQuery.role = 'user'
    initialQuery.new = true
    initialQuery.type = 'users'

    return (
        <>
            <div>
                <ResourceList
                    paginated
                    paginationLimit={21}
                    initialQuery={initialQuery}
                    // itemClickPath={"/users/:item.id"}
                    apiUrl={'/v1/users'}
                    getItemsFromResponse={(data) => data?.results}
                    fields={[
                        {
                            column: 1,
                            getValue: (item) => (
                                <Link to={`/users/${item.id}`}>
                                    asdsd
                                    <br />
                                    Test
                                    <br />
                                    Test
                                </Link>
                                // <ContactCard
                                //     topRightContent={
                                //         <BlockStack itemsEnd>
                                //             <ContactCardTags user={item} />
                                //         </BlockStack>
                                //     }
                                //     withNameLink
                                //     user={{
                                //         ...item,
                                //     }}
                                //     bottomLeftContent={
                                //         <ContactCardContactInfo user={item} />
                                //     }
                                // />
                            ),
                        },
                    ]}
                />
            </div>
        </>
    )
}
